import { Pipe, PipeTransform } from '@angular/core';
import { TemplateSlot } from '../interfaces';

@Pipe({
    name: 'requiredMarker'
})
export class RequiredMarkerPipe implements PipeTransform {
    transform(value: string | null | undefined, requiredConfig: boolean | TemplateSlot[] | null | undefined): string {
        if (!value) return '';

        let isRequired: boolean;

        if (typeof requiredConfig === 'boolean') {
            isRequired = requiredConfig;
        } else if (Array.isArray(requiredConfig)) {
            isRequired = requiredConfig.some(slot => !slot.isOptional);
        } else {
            isRequired = false;
        }

        return isRequired ? `${value}*` : value;
    }
}
